import React from 'react';
import { motion } from 'framer-motion';
import backgroundImage from '../../assets/images/bg123.jpg'; // Replace with your actual image path

const Info = () => {
  return (
    <div
      className="relative w-full bg-fixed bg-center bg-cover py-20 px-6 sm:px-10 lg:px-32 xl:px-48"
      style={{
        backgroundImage: `linear-gradient(rgba(248, 248, 248, 0.15), rgba(253, 249, 249, 0.55)), url(${backgroundImage})`
      }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <motion.h2 
          className="text-3xl md:text-4xl font-black text-[deepskyblue] mb-6"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
         <h2 className="text-3xl font-bold text-gray-800 mb-2" style={{color:'deepskyblue'}}>About LABH Industries</h2>
        </motion.h2>

        <motion.p
          className="text-lg text-[#000] font-medium leading-8 mb-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          LABH Industries is fueled by a passionate and expert group of amazing workforces. We specialize in providing a wide range of world-class EPC, Equipment Solutions & Services to a broad spectrum of industries, ensuring innovation, reliability, and excellence in execution.
        </motion.p>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 gap-x-16 text-left text-[#000] text-[17px] leading-7 mb-10"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.15 }
            }
          }}
        >
        
          <div className="space-y-4">
            <motion.div variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}>• Engineered constructions including modular fabrication</motion.div>
            <motion.div variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}>• Export projects: structural material frame fabrication & packing</motion.div>
            <motion.div variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}>• Containerized offices & structures</motion.div>
          </div>
          <div className="space-y-4">
            <motion.div variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}>• Civil constructions for Factories, Hotels, Institutions, Office Buildings, Supermarkets & Hospital Infrastructures</motion.div>
            <motion.div variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}>• Bulk material storage terminals</motion.div>
          </div>
        </motion.div>

        <motion.p
          className="text-[#000] text-[17px] leading-7 mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Our assets in terms of People, Equipment & Infrastructure empower our customers with end-to-end solutions. With all necessary services under one umbrella, our projects are easier to manage and quicker to deliver while maintaining the highest standards of quality, health, and safety.
        </motion.p>

        <motion.p
          className="text-[#000] text-[17px] leading-7"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.6 }}
        >
          Currently, we are executing over <span className="font-semibold text-[deepskyblue]">200,000 SQM</span> of work for PEB, RCC, and other construction projects.
        </motion.p>
      </div>
    </div>
  );
};

export default Info;
